module.exports = __webpack_public_path__ + "static/media/player-shoot.19cae314.svg";